module.exports = __webpack_public_path__ + "d5e71e72f8c5c821f94be80e1ddeba87.svg";